import gql from 'graphql-tag';

export const bundle = gql`
  fragment Bundle on Bundle {
    createdAt
    updatedAt
    id
    businessId
    enabled
    includeCardData
  }
`;

// WorkspaceRef and WorkspaceSectionRef are defined here to avoid circular dependency with channel.ts
export const workspaceRef = gql`
  fragment WorkspaceRef on WorkspaceRef {
    id
    name
    imageUrl
    description
  }
`;

export const workspaceSectionRef = gql`
  fragment WorkspaceSectionRef on WorkspaceSectionRef {
    id
    title
    workspaces {
      ...WorkspaceRef
    }
  }

  ${workspaceRef}
`;

export const workspacePublicBundle = gql`
  fragment WorkspacePublicBundle on WorkspacePublicBundle {
    id
    enabled
    name
    description
    type
    includeCardData
    workspace {
      ...WorkspaceRef
    }
  }

  ${workspaceRef}
`;

export const workspaceSectionPublicBundle = gql`
  fragment WorkspaceSectionPublicBundle on WorkspaceSectionPublicBundle {
    id
    enabled
    name
    description
    type
    includeCardData
    workspaceSection {
      ...WorkspaceSectionRef
    }
  }

  ${workspaceSectionRef}
`;

export const publicBundle = gql`
  fragment PublicBundle on AnyPublicBundle {
    ...WorkspacePublicBundle
    ...WorkspaceSectionPublicBundle
  }

  ${workspacePublicBundle}
  ${workspaceSectionPublicBundle}
`;

export const WorkspaceDuplicationResult = gql`
  fragment WorkspaceDuplicationResult on WorkspaceDuplicationResult {
    type
    workspace {
      id
      slug
    }
  }
`;

export const WorkspaceSectionDuplicationResult = gql`
  fragment WorkspaceSectionDuplicationResult on WorkspaceSectionDuplicationResult {
    type
    workspaceSection {
      id
      title
      createdAt
      updatedAt
      channelAssociations {
        channelId
        workspaceSectionId
      }
      bundle {
        ...Bundle
      }
    }
  }

  ${bundle}
`;

export const AnyDuplicationResult = gql`
  fragment AnyDuplicationResult on AnyDuplicationResult {
    ...WorkspaceDuplicationResult
    ...WorkspaceSectionDuplicationResult
  }

  ${WorkspaceDuplicationResult}
  ${WorkspaceSectionDuplicationResult}
`;
